import React from 'react';
import { t } from 'i18n';

import ActionButton from 'Components/Base/ActionButton';

import successImage from './success.svg';

const i18nOpts = { scope: 'registration.email_confirmation_modal' };

const Success = () => {
  return <>
    <div className="registrationV2__email_confirmation_modal__success_body">
      <img src={successImage} className="registrationV2__email_confirmation_modal__success_image"/>
      <h2 className="registrationV2__email_confirmation_modal__header">{t('success_header', i18nOpts)}</h2>
      <div>{t('success_info', i18nOpts)}</div>
    </div>
    <div className="ModalV2__footer registrationV2__email_confirmation_modal__success_footer">
      <ActionButton
        content={t('log_in', i18nOpts)}
        onClick={() => window.location.replace('/login')}
        className="registrationV2__email_confirmation_modal__to_login"
      />
    </div>
  </>;
};

export default Success;
